import React from 'react'
import FinalMolGrid from '../../../../../../../components/FinalMolGrid/FinalMolGrid'
import Buttons from '../../../../../../../components/ui/button/Buttons'
import { NewRefrenceTaskGridConfig } from './config/NewRefrenceTaskGridConfig.Data'
import { useRef } from 'react'
import ToastService from '../../../../../../../services/toastService/ToastService'
import { useState } from 'react'
import { useEffect } from 'react'
import { useAddAttachedTaskMutation, useLazyGetAttachTaskQuery } from '../../../../../../../app/services/attachedTaskAPI'

const NewReferenceTaskList = (props) => {
  const molGridRef = useRef();
  const [dataSource, setDataSource] = useState([]);
  const [refTaskListData, setRefTaskListData] = useState([]);

  const [
    getAttachTask,
    {
      isLoading: isAttachTaskLoading,
      isFetching: isAttachTaskFetching,
      isSuccess: isgetAttachTaskSuccess,
      data: attachTaskListData,
    },
  ] = useLazyGetAttachTaskQuery();

  
  const [
    addAttachedTask,
    { isLoading: isAdding, isSuccess: isAdded, data: attachedTaskAddData },
  ] = useAddAttachedTaskMutation();

  const handleAddClick = () => {
    let refTaskIds = refTaskListData.map((item) => item.taskId).toString();
    const req = {
      linkedTaskIds: refTaskIds,
      taskId: props.taskId,
    };
    addAttachedTask(req);
  };

  const handleCloseClick = () => {
    props?.onClose();
  };

  const handleColumnsChange = (fieldName, rowData, rowIndex) => {
    setRefTaskListData((prev) => {
      if (rowData.isSelected) {
        return [...prev, rowData];
      } else {
        return prev.filter((task) => task.taskId !== rowData.taskId);
      }
    });
  };

  useEffect(() => {
    if (props.projectId && props.taskId) {
      const req = {
        projectId: props.projectId,
        taskId: props.taskId,
      };
      getAttachTask(req);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.projectId, props.taskId]);

  useEffect(() => {
    if (!isAttachTaskFetching && isgetAttachTaskSuccess && attachTaskListData) {
      setDataSource(attachTaskListData);
    }
  }, [isAttachTaskFetching, isgetAttachTaskSuccess, attachTaskListData]);

  useEffect(() => {
    if (isAdded && attachedTaskAddData) {
      if (attachedTaskAddData.errorMessage.includes("select")) {
        ToastService.error(attachedTaskAddData.errorMessage);
        return;
      } else {
        ToastService.success(attachedTaskAddData.errorMessage);
        props.onSuccess?.();
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdded, attachedTaskAddData]);


  return (
    <div>
      <div className="reference-task-grid">
        <FinalMolGrid
          ref={molGridRef}
          dataSource={dataSource}
          allowPagination={false}
          isLoading={isAttachTaskLoading}
          onColumnChange={handleColumnsChange}
          configuration={NewRefrenceTaskGridConfig}
        />
        <div className="col-12 d-flex justify-content-end mt-4 button-submit">
          <Buttons
            textWithIcon={false}
            fontIcon={false}
            buttonTypeClassName="dark-btn"
            buttonText="Cancel"
            onClick={handleCloseClick}
          />
          <Buttons
            textWithIcon={true}
            fontIcon={true}
            iconName="ic:round-add"
            buttonTypeClassName="theme-btn ml-2"
            buttonText="Attach Task"
            onClick={handleAddClick}
            isLoading={isAdding}
          />
        </div>
      </div>
    </div>
  )
}

export default NewReferenceTaskList
